import backgroundImg from "../../shared/assets/images/bg2.jpg";
import "./style.scss";

export default function About() {
    return (
        <div>
            <div className="about-page bg-black flex items-center">
                <div className="about-text ml-auto mr-auto">
                    <h2 className="text-2xl font-bold text-center">
                        We are TIPTOP, we pursue tiptop visual art.
                    </h2>

                    <p className="mt-10">
                        Tiptop is a high-end architectural visualization studio based in Shanghai. We believe that compelling visual art has the power to ignite imagination and inspire people to envision the lives they aspire to lead.
                    </p>

                    <p className="mt-4">
                        At Tiptop, we see ourselves as both observant storytellers and architects of meaningful narratives. We uncover the subtle beauty within everyday life, listening closely to the unique stories embedded in each building. Our mission is to be curators of imagination—bridging the complex realities of the built environment with the visionary ideas of designers.
                    </p>

                    <p className="mt-4">
                        Driven by a team of industry-leading creatives, we operate at the intersection of innovation and craftsmanship. Our core services include still imagery, fly-through animations, multimedia productions, and interactive experiences. We transcend traditional boundaries, blending artistry with cutting-edge technology to deliver bespoke visual solutions tailored to each client’s vision.
                    </p>
                    <p className="mt-4">
                        To explore our work, choose the link that suits your needs. Let us take you on an extraordinary visual journey.
                    </p>
                </div>
            </div>
        </div>
    );
}
